<template>
    <div class="column is-narrow seatmap-aisle">
        
    </div>
</template>

<script>

export default {
  components: {
  },
  methods: {
  },
  props: {
  },
  computed: {

  }
}

</script>

<style scoped>
.seatmap-aisle {
    width:10px; 
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

</style>
